import type { SubscriptionPlan } from "../types";

export type AccessLevel = "free" | "trial" | "premium";
export function hasComplimentaryAccess(sub: {
  status: string; end_date: string | null; payment_provider?: string | null;
} | null): boolean {
  return sub?.status === "active" && sub.payment_provider === "complimentary" && sub.end_date === "infinity";
}
export function isExpired(value: string | null | undefined, now = Date.now()): boolean {
  const end = value ? Date.parse(value) : NaN;
  return !Number.isFinite(end) || end <= now;
}

export function resolveAccessLevel(sub: {
  status: string; plan: string; end_date: string | null; trial_end: string | null;
  current_period_end?: string | null;
  payment_provider?: string | null;
} | null, now = Date.now()): { level: AccessLevel; isActive: boolean; plan: SubscriptionPlan; status: string } {
  const status = sub?.status ?? "";
  const free = { level: "free" as const, isActive: false, plan: "FREE" as const, status };
  if (!sub || !["active", "trialing"].includes(status)) return free;
  if (hasComplimentaryAccess(sub)) return { level: "premium", isActive: true, plan: "PREMIUM_YEARLY", status };
  const end = status === "trialing" ? sub.trial_end : sub.end_date ?? sub.current_period_end;
  if (isExpired(end, now)) return { ...free, status: "expired" };
  const aliases: Record<string, SubscriptionPlan> = {
    monthly: "PREMIUM_MONTHLY", premium_monthly: "PREMIUM_MONTHLY",
    yearly: "PREMIUM_YEARLY", premium_yearly: "PREMIUM_YEARLY", trial: "TRIAL",
  };
  const plan = aliases[sub.plan.toLowerCase()];
  if (!plan || (status === "active" && plan === "TRIAL")) return free;
  return { level: status === "trialing" ? "trial" : "premium", isActive: true, plan, status };
}
